export const GET_HOME_DATA = "GET_HOME_DATA";
export const GET_BRANCHES = "GET_BRANCHES";
export const GET_APPOINTMENT_TYPES = "GET_APPOINTMENT_TYPES";
export const CHANGE_PARAMS_BRANCH_ID = "CHANGE_PARAMS_BRANCH_ID";
export const CHANGE_BRANCH_NAME = "CHANGE_BRANCH_NAME";
export const CHANGE_APPOINTMENT_TYPE_NAME = "CHANGE_APPOINTMENT_TYPE_NAME";
export const CHANGE_PARAMS_APPOINTMENT_TYPE_ID = "CHANGE_PARAMS_APPOINTMENT_TYPE_ID";
export const CHANGE_PARAMS_APPOINTMENT_DATE = "CHANGE_PARAMS_APPOINTMENT_DATE";
export const CHANGE_APPOINTMENT_DATE = "CHANGE_APPOINTMENT_DATE";
export const VERIFY_TOKEN_RESPONSE = "VERIFY_TOKEN_RESPONSE";
export const ADD_POINT_PARAMS = "ADD_POINT_PARAMS";
export const PARAMS_VERIFY_TOKEN_RESPONSE = "PARAMS_VERIFY_TOKEN_RESPONSE";
export const CHANGE_PARAMS_FORM_VAL = "CHANGE_PARAMS_FORM_VAL";
export const AVAILABLE_HOUR = "AVAILABLE_HOUR";
export const GET_APPOINTMENT = "GET_APPOINTMENT";
export const SET_LONG_TOKEN = "SET_LONG_TOKEN";
export const SET_TOKEN = "SET_TOKEN";
export const GET_EVALUATE_APPOINTMENT = "GET_EVALUATE_APPOINTMENT";
export const GET_APPOINTMENT_PAGE_STEPS = "GET_APPOINTMENT_PAGE_STEPS";
export const SET_PARAMS_FROM_APPOINTMENT_EDIT = "SET_PARAMS_FROM_APPOINTMENT_EDIT";
export const USER_COMPLETED_STEPS = "USER_COMPLETED_STEPS";
export const GET_APPOINTMENT_CHANGE_DATE = "GET_APPOINTMENT_CHANGE_DATE";
export const SET_UPDATE_TOKEN = "SET_UPDATE_TOKEN";
export const CHANGE_CALENDAR_STEP = "CHANGE_CALENDAR_STEP";
export const RESET_VALUES = "RESET_VALUES";
export const ADMIN_CONFIG = "ADMIN_CONFIG";
export const APPOINTMENT_EVALUATED_BEFORE = "APPOINTMENT_EVALUATED_BEFORE";
export const GET_PROVIDENCE = "GET_PROVIDENCE";
export const GET_DISTRICTS = "GET_DISTRICTS";
export const GET_QUARTERS = "GET_QUARTERS";
export const GET_SERVICE_CONFIG = "GET_SERVICE_CONFIG";
export const SET_ADDRESS_FORM_DATA = "SET_ADDRESS_FORM_DATA";
export const SET_TIME_FORM_DATA = "SET_TIME_FORM_DATA";
export const SET_TYPE_FORM_DATA = "SET_TYPE_FORM_DATA";

export const SET_NOTE_FORM_DATA = "SET_NOTE_FORM_DATA";
export const SET_USERINFO_FORM_DATA = "SET_USERINFO_FORM_DATA";
export const RESET_SERVICE_DATA = "RESET_SERVICE_DATA";
export const SET_SERVICE_CENTERS = "SET_SERVICE_CENTERS";
